@if (soundSrc()) {
  <audio #audioPlayer [src]="soundSrc()" preload="auto"></audio>
}

@if (show()) {
  <div class="announcement-balloon">
    @if (showCloseButton()) {
      <button
        type="button"
        class="announcement-close-btn"
        aria-label="Fechar aviso"
        (click)="dismiss($event)"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    }
    <div class="announcement-caret"></div>
    <div class="announcement-header">
        <span class="announcement-badge">
          <span class="badge-shine"></span>
          <i class="fa-solid fa-sparkles badge-icon" aria-hidden="true"></i>
          <span class="badge-text">{{ badgeText() }}</span>
        </span>
      <span class="announcement-title">{{ title() }}</span>
    </div>
    <span class="announcement-text" [innerHTML]="description()"></span>
  </div>
}